import i18n from '@/common/i18n/i18n'

export function gaLang () {
  if (process.env.VUE_APP_NODE_ENV !== 'production') {
    return
  }

  window.dataLayer = window.dataLayer || []
  function gtag () {
    // eslint-disable-next-line no-undef
    dataLayer.push(arguments)
  }

  var eventLabel = i18n.locale
  var data = {
    event_category: 'engagement',
    event_label: eventLabel
  }

  gtag('event', eventLabel, data)
  // if (process.env.VUE_APP_NODE_ENV !== 'production') {
  //   console.group('googleAnalytics: Lang')
  //   console.log(JSON.stringify(data))
  //   console.groupEnd()
  // }
}
